// extracted by mini-css-extract-plugin
export default {"descr":"Paragraph_descr__G74UR"};